import {logInfo, logWarn} from "./debugLog";

const GATracker = {};

GATracker.measurementId = process.env.REACT_APP_GA4_MEASUREMENT_IT;

GATracker.EVENTS = {
    APPLICATION_INIT:       { name: 'application:init',                  category: 'application',    action: 'init'                       },
    APPLICATION_DESTROY:    { name: 'application:destroy',               category: 'application',    action: 'destroy'                    },
    WIDGET_CLOSE:           { name: 'widget:close',                      category: 'widget',         action: 'close'                      },
    WIDGET_OPEN:            { name: 'widget:open',                       category: 'widget',         action: 'open'                       },
    CUSTOMER_SELECTION:     { name: 'widget:customer_selection',         category: 'widget',         action: 'customer_selection'         },
    PRODUCT_SELECTION:      { name: 'widget:product_selection',          category: 'widget',         action: 'product_selection'          },
    LEAD_FORM_OPEN:         { name: 'leadform:open',                     category: 'leadform',       action: 'leadform_open'              },
    LEAD_FORM_CLOSE:        { name: 'leadform:close',                    category: 'leadform',       action: 'leadform_close'             },
    LEAD_FORM_SUBMIT:       { name: 'leadform:submit',                   category: 'leadform',       action: 'leadform_submit'            },
    LEAD_FORM_RESULT_OK:    { name: 'leadform:submit:ok',                category: 'leadform',       action: 'leadform_submit_ok'         },
    LEAD_FORM_RESULT_KO:    { name: 'leadform:submit:ko',                category: 'leadform',       action: 'leadform_submit_ko'         },
    FILE_DOWNLOAD:          { name: 'file:download',                     category: 'attachment',     action: 'file_download'              },
    SERVICE_ACCORDION:      { name: 'widget:service_accordion:{status}', category: 'widget',         action: 'service_accordion_{status}' },
};

GATracker.cookiesConsent = false;

GATracker.init = ({cookiesConsent}) => {

    GATracker.cookiesConsent = cookiesConsent;

    if(GATracker.cookiesConsent && GATracker.measurementId && GATracker.measurementId !== "") {

        if(!document.querySelector("script[data-measurement-id="+GATracker.measurementId+"]")) {
            const script = document.createElement('script');
            script.async = true;
            script.type = "text/javascript";
            script.src = 'https://www.googletagmanager.com/gtag/js?id='+GATracker.measurementId;
            script.setAttribute('data-measurement-id', GATracker.measurementId);
            document.head.appendChild(script);
        }

        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];

        window.gtag = function (){
            window.dataLayer.push(arguments);
        }
        window.gtag('js', new Date());
        window.gtag('config', GATracker.measurementId);
        /* eslint-enable */

        if(!GATracker.measurementId || GATracker.measurementId === '') {
            logWarn('No GOOGLE_ANALYTICS_ID configured for current environment');
            window.isGA4Enabled = false;
        } else {
            window.isGA4Enabled = true;
        }
    }


};

const GA4TrackEvent = ({name,category,action,label,value,link,customData}) => {
    if(GATracker.cookiesConsent && window.gtag && typeof window.gtag === 'function') {

        if(!name || name === '') {
            name = category + ':' + action + (label && label !== '') ? ':' + label : '';
        }
        if(!label || label === '') {
            label = name;
        }

        const eventData = {
            "send_to": GATracker.measurementId,
            "event_category": category && category !== '' ? category : null,
            "event_action": action && action !== '' ? action : null,
            "event_label": label && label !== '' ? label : null,
            "event_value": value && value !== '' ? Number(value) : null,
            "event_link": link && link !== '' ? link : null,
            ...customData
        };
        window.gtag('event', name, eventData);

        logInfo('GA4TrackEvent', name, eventData);
    }

}

GATracker.trackEvent = (eventParametersObject) => {
    if(GATracker.cookiesConsent && window.isGA4Enabled) {
        GA4TrackEvent(eventParametersObject);
    }
}




const GAEventBuildVehicleData = ({appData}) => {
    if(!appData) {
        return {}
    }
    return {
        vehicle_eim: appData.input?.EIM,
        vehicle_brand: appData.input?.brand,
        vehicle_model: appData.input?.model,
        vehicle_version: appData.input?.version,
        vehicle_type: appData.input?.vehicleType,
        vehicle_price: appData.input?.price,
        vehicle_price_dimension: appData.input?.price,
    }
}

const GAEventBuildFinancialConfigurationData = ({financialConfiguration}) => {
    if(!financialConfiguration) {
        return {}
    }

    return {
        financial_product_type: financialConfiguration.productTypeCode,
        financial_product_name: financialConfiguration.rentalProductName,
        customer_type: financialConfiguration.selectedCustomer,
        duration: financialConfiguration.duration,
        duration_dimension: financialConfiguration.duration,
        total_installment: financialConfiguration.totalInstallment,
        total_installment_dimension: financialConfiguration.totalInstallment,
        mileage: financialConfiguration.mileage,
        mileage_dimension: financialConfiguration.mileage
    }
}

const GAEventBuildLabel = ({appData, customer, productTypeCode}) => {
    let labelParts = [];
    if(appData.input?.EIM && appData.input?.EIM !== "") {
        labelParts.push("Vehicle EIM: " + appData.input.EIM);
    }
    if(typeof appData.input?.price !== 'undefined') {
        labelParts.push("Vehicle Price: " + appData.input.price);
    }
    if(customer && customer !== '') {
        labelParts.push("Customer selection: " + customer);
    }
    if(productTypeCode && productTypeCode !== '') {
        labelParts.push("Product type selection: " + productTypeCode);
    }

    return labelParts.join(" - ");

}

export const GAEventBuildObject = ({event, appData, financialConfiguration}) => {
    return {
        name: event.name,
        category: event.category,
        action: event.action,
        label: event.label || GAEventBuildLabel({
            appData,
            customer: financialConfiguration?.customer || null,
            productTypeCode: financialConfiguration?.productTypeCode || null
        }),
        customData: {
            page_type: 'page',
            widget_language: appData.config?.lang,
            market_code: appData.config?.marketCode,
            ...GAEventBuildVehicleData({appData}),
            ...GAEventBuildFinancialConfigurationData({financialConfiguration}),
        }
    };
}


export default GATracker;